module.exports = __webpack_public_path__ + "img/no-prize.ca33752a.svg";